export const environment = {
    production: true,
    googleMapsApiKey: 'AIzaSyAdehfQwDgv8G8J7zbAc-197bEIthWpGKs',
    recaptcha: {
        siteKey: '6LcYZroqAAAAAHS3AGlsPzDqCReZHFsc_TiJGCa1',
    },
};
